import { reloadDatatable } from "../common/datatables";

const props = {
    contactUsEditCategoryDatatableMarker: '.marker-contact-us-category-edit',
    contactUsChildCategoriesDatatable: '#dt-contact-us-child-categories',
    contactUsChildContentItemsDatatable: '#dt-contact-us-child-content-items',
    searchterm_selector: '#SearchField'
}; 

export function initDtAdminContactUsEditCategory() {

    if ($(props.contactUsEditCategoryDatatableMarker).length) {
        dtAdminContactUsChildCategories(initContactUsChildCategoriesDatatableEvents);
        dtAdminContactUsChildContentItems(initContactUsChildContentItemsDatatableEvents);
    }
}

//START - CHILD CATEGORIES DT MANAGEMENT

function initContactUsChildCategoriesDatatableEvents() {

    //PURPOSE: sets up the full row click select for the user search dt
    $(props.contactUsChildCategoriesDatatable).off('click').on('click', 'tbody td', function (event) {

        if ($(this).hasClass('dataTables_empty')) {

            //if no results are returned for a datatable it adds the message as a row.
            //as such this event binder still acts when theres no row to click through on.
            //the check above neutralises this issue
            return;
        }

        var itemId = $(event.currentTarget).parent('tr').data('id');

        window.location.href = '/administration/contactusmanagement/editcategory/' + itemId;
    });
}

function dtAdminContactUsChildCategories(onloadCallback) {

    if ($(props.contactUsChildCategoriesDatatable).length === 0) return false;

    $(props.contactUsChildCategoriesDatatable).DataTable({
        iDisplayLength: 100,
        initComplete: onloadCallback,
        paging: true,
        info: true,
        ordering: true,
        filter: false,
        lengthChange: false,
        serverSide: true,
        deferRender: true,
        ajax: {
            url: '/administration/contactusmanagement/contactuschildcategories',
            data: function (d) {
                d.searchterm = null;
                d.parentId = $(props.contactUsChildCategoriesDatatable).data('id');
            },
            dataSrc: function (data) {

                if (data.responseType === 'SUCCESS')
                    return data.data;
                else
                    responseError(data);
            },
            error: function (jqXHR, textStatus, errorThrown) {
                console.log(textStatus);
            },
            type: 'POST'
        },

        columns: [
            { data: 'level', name: 'Level' },
            { data: 'title', name: 'Title' },
            { data: 'index', name: 'Index' }
        ],
        order: [[2, "asc"]],

        createdRow: function (row, data, dataIndex) {
            $(row).attr('data-id', data.id);
        }

    });
}

//END - CHILD CATEGORIES DT MANAGEMENT


//START - CHILD PRODUCTS DT MANAGEMENT

function initContactUsChildContentItemsDatatableEvents() {

    //PURPOSE: sets up the full row click select for the user search dt
    $(props.contactUsChildContentItemsDatatable).off('click').on('click', 'tbody td', function (event) {

        if ($(this).hasClass('dataTables_empty')) {

            //if no results are returned for a datatable it adds the message as a row.
            //as such this event binder still acts when theres no row to click through on.
            //the check above neutralises this issue
            return;
        }

        var itemId = $(event.currentTarget).parent('tr').data('id');

        window.location.href = '/administration/contactusmanagement/editcontentitem/' + itemId;
    });
}

function dtAdminContactUsChildContentItems(onloadCallback) {

    if ($(props.contactUsChildContentItemsDatatable).length === 0) return false;

    $(props.contactUsChildContentItemsDatatable).DataTable({
        iDisplayLength: 100,
        initComplete: onloadCallback,
        paging: true,
        info: true,
        ordering: true,
        filter: false,
        lengthChange: false,
        serverSide: true,
        deferRender: true,
        ajax: {
            url: '/administration/contactusmanagement/contactuschildcontentitems',
            data: function (d) {
                d.searchterm = null;
                d.parentId = $(props.contactUsChildContentItemsDatatable).data('id');
            },
            dataSrc: function (data) {

                if (data.responseType === 'SUCCESS')
                    return data.data;
                else
                    responseError(data);
            },
            error: function (jqXHR, textStatus, errorThrown) {
                console.log(textStatus);
            },
            type: 'POST'
        },

        columns: [
            { data: 'header', name: 'Header' },
            { data: 'content', name: 'Content' },
            { data: 'index', name: 'Index' }
        ],
        order: [[2, "asc"]],

        createdRow: function (row, data, dataIndex) {
            $(row).attr('data-id', data.id);
        }

    });
}

//END - CHILD PRODUCTS DT MANAGEMENT